import MainContext from './MainContext';

export default MainContext;
